<template>
    <div class="action-header">
        <el-upload
            :disabled="loading"
            :http-request="addDevice"
            :limit="1"
            :show-file-list="false"
            accept=".xlsx"
            action="//"
        >
            <el-button :loading="loading" class="btn-add" icon="el-icon-upload" type="primary">添加设备</el-button>
        </el-upload>
        <el-input class="input" clearable placeholder="请输入关键字" v-model="key">
            <i @click="clickSearch" class="el-input__icon el-icon-search btn-search" slot="suffix" />
        </el-input>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { api, postFile } from '../../service';

const { mapActions } = createNamespacedHelpers('device');

export default {
    data() {
        return {
            key: '',
            loading: false,
        };
    },
    methods: {
        ...mapActions(['changeSearch']),
        addDevice({ file }) {
            const data = new FormData();
            data.append('devices', file);
            this.loading = true;
            postFile(api.device.import, data)
                .then(() => {
                    this.key = '';
                    this.clickSearch();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        clickSearch() {
            this.changeSearch({ key: this.key, page: 1 });
        },
    },
};
</script>

<style lang="less" scoped>
.action-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    overflow: hidden;
    .btn-add {
        margin-right: 20px;
    }
    .input {
        width: 250px;
    }
    .btn-search {
        width: 30px;
        font-size: 18px;
        cursor: pointer;
        &:hover {
            color: #409eff;
        }
    }
}
</style>
